<mat-card>
  <div class="title">
    <h1>{{'Select a Form' | translate | async}}</h1>
  </div>
  
  <ng-container *ngIf="formCategories!= null">
  
    <div style="margin: 24px 16px; display: flex; flex-wrap: wrap;padding: 1%;">
      <ng-container *ngFor="let fc of formCategories">
        <div style="flex: 1 0 40%">
          <div>
            <h3 title="{{fc.Description}}"><b><u>{{fc.Name}}</u></b></h3>
          </div>
          <ng-container *ngIf="forms!= null">
            <ng-container *ngFor="let f of forms">
              <ng-container *ngIf="f.FormCategoryID == fc.ID">
  
                <div title="{{f.Description}}">
                  <span
                  style="cursor: pointer;min-width: 50px;display: flex;flex-direction: row;align-items: center;justify-content: center;"
                  class="material-icons-outlined">
                 
                  
                </span>
                  <ng-container *ngIf="f.IsDigital == false">
                    <p> <i (click)="DownloadForm(f.ID,f.Filename)" style="cursor: pointer;vertical-align: bottom; margin-left: 2%;" class="material-icons">picture_as_pdf</i>
                      <a (click)="DownloadForm(f.ID,f.Filename)" style="cursor: pointer;font-size: 17px;">{{f.Name}}</a>
                     </p>
                  </ng-container>
  
                  <ng-container *ngIf="f.IsDigital == true">
                    <p><i (click)="NavigateToUploadDigitalFormsComponent(f.ID)" style="cursor: pointer;vertical-align: bottom; margin-left: 2%;" 
                      class="material-icons">dynamic_form</i>
                      <a (click)="NavigateToUploadDigitalFormsComponent(f.ID)" style="cursor: pointer;font-size: 17px;">{{f.Name}}</a> 
                      </p>
                  </ng-container>
  
                </div>
              </ng-container>
            </ng-container>
          </ng-container>
        </div>
  
      </ng-container>
    </div>
  
  </ng-container>
</mat-card>
